
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"60","viewBox":"0 0 29 60","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.155 24.2c-.222 0-.444-.055-.666-.166l-8.437-4.885c-.389-.222-.61-.666-.61-1.166V8.27c0-.5.221-.888.665-1.165l8.437-4.885c.389-.222.888-.222 1.332 0l8.437 4.885c.389.222.666.666.666 1.165v9.77c0 .499-.277.887-.666 1.165l-8.492 4.829c-.167.11-.389.166-.666.166zM7.05 17.262l7.105 4.107 7.104-4.107V9.047L14.155 4.94 7.05 9.047v8.215z","fill":"#000"}}),_c('path',{attrs:{"d":"M14.154 60c-.278 0-.5-.055-.722-.166L.722 52.452C.278 52.174 0 51.73 0 51.175V36.522c0-.5.278-1 .722-1.277l5.717-3.33c.721-.389 1.61-.166 1.998.555.388.666.166 1.61-.555 1.998l-4.996 2.886v12.989l11.268 6.494 11.267-6.495V37.355L8.215 27.42c-.444-.277-.722-.721-.722-1.277v-5.217c0-.832.666-1.443 1.443-1.443.833 0 1.443.666 1.443 1.443v4.33l17.207 9.935c.444.277.721.721.721 1.276V51.12c0 .555-.277.999-.721 1.276l-12.71 7.327c-.167.222-.445.277-.722.277zM5.55 4.884L9.27 2.72 5.55 0v4.884zM23.256 4.884L19.537 2.72 23.256 0v4.884z","fill":"#000"}})])
          )
        }
      }
    